import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/WarehouseGame/scenes/GameIntro';

interface PhaserWarehouseGameProps {
    onComplete: () => void;

}

interface PhaserWarehouseGameState {
}

const gameConfig: GameConfig = {
    title: "Landscaping Game",
    version: "0.9.3",
    backgroundColor: "#000000",
};

class PhaserWarehouseGame extends React.Component<PhaserWarehouseGameProps, PhaserWarehouseGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserWarehouseGameProps) {
        super(props);
        bindAllOfThis(this, PhaserWarehouseGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserWarehouseGame;



// WEBPACK FOOTER //
// ./src/games/WarehouseGame/Main.tsx